import React, { useEffect, useState } from "react";
import useUrlParams from "../customHooks/useUrlParams";
import { useLazyQuery } from "@apollo/client";
import { responseType } from "../utils/formTypes";
import {
  FormAutocomplete,
  LabeledAutocomplete,
  formClasses,
  labelClasses,
} from "../styles/AutocompleteStyles";
import { TextField } from "@mui/material";
import { GetDeviceTypes } from "../components/modules/asset/masters/deviceType/queries/queries";
import {
  GetDeviceTypesResult,
  GetDeviceTypesVars,
} from "../components/modules/asset/masters/deviceType/queries/types";

interface Props {
  onKeyDown:
    | ((
        event: React.KeyboardEvent<HTMLDivElement> & {
          defaultMuiPrevented?: boolean;
        }
      ) => void)
    | undefined;
  onChange: (newValue: responseType) => void;
  value: number;
  label: string;
  placeholder?: string;
}

const DeviceTypesSelect = ({
  onChange,
  onKeyDown,
  value,
  label,
  placeholder,
}: Props) => {
  const { customer_id } = useUrlParams();
  const [searchData, setSearchData] = useState("");
  const [categoryOptions, setCategoryOptions] = useState<responseType[]>([]);
  const [autoValue, setAutoValue] = useState<responseType | null>(null);
  const [getDeviceTypes, { data, loading }] = useLazyQuery<
    GetDeviceTypesResult,
    GetDeviceTypesVars
  >(GetDeviceTypes);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id)
          getDeviceTypes({
            variables: {
              customerID: customer_id,
            },
          });
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [customer_id, getDeviceTypes]);

  useEffect(() => {
    if (value) {
      const foundValue = categoryOptions.find(
        ({ value: optionsValue }) => Number(optionsValue) === Number(value)
      );

      setAutoValue(foundValue ? foundValue : null);
    } else {
      setAutoValue(null);
    }
  }, [value, data, categoryOptions]);

  useEffect(() => {
    if (data && data.GetDeviceTypes) {
      setCategoryOptions(
        data.GetDeviceTypes.map((node) => ({
          label: node.deviceType,
          value: node.id,
        }))
      );
    }
  }, [data]);

  let commonAutocompleteClassName = label
    ? labelClasses.inputRoot
    : formClasses.inputRoot;
  let commonTextFieldClassName = label
    ? labelClasses.formControlRoot
    : formClasses.formControlRoot;

  const Autocomplete =
    label.length > 0 ? LabeledAutocomplete : FormAutocomplete;

  return (
    <Autocomplete
      className={commonAutocompleteClassName}
      options={categoryOptions}
      //   onKeyDown={(e) => {
      //     if (e.key === Keys.ENTER) {
      //       e.preventDefault();
      //       handleMUISelectEvent(e);
      //     }
      //   }}
      value={autoValue}
      openOnFocus
      forcePopupIcon
      // slotProps={{
      //   listbox: {
      //     onScroll: handleScroll,
      //   },
      // }}
      onChange={(e, newValue) => {
        onChange(newValue as responseType);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label={label}
          onChange={(e) => setSearchData(e.target.value)}
          className={commonTextFieldClassName}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          placeholder={placeholder}
        />
      )}
    />
  );
};

export default DeviceTypesSelect;
